export default "https://assets-v2.scaler.com/packs/images/Logomark_Scaler.56943c.svg";